/**
 * @file: index.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The collapsible filter panel revealed by the status-row toggle: search box,
 * the date-range picker card, the origin + intention bar, then the sort + owner
 * bar. It is purely a layout container — every control is fully driven by the
 * lead-list controls hook.
 */

import { LeadListControls } from '@euler/app/flows/leads/pages/list/functions/useLeadListControls';
import { View } from 'react-native';
import { LeadSearchBox } from './LeadSearchBox';
import { OriginIntentionBar } from './OriginIntentionBar';
import { SortOwnerBar } from './SortOwnerBar';
import { LeadDateRangePicker } from './date-range-picker';

// Not memoized: `controls` is a fresh object every render, so memo could never
// skip — and the panel only mounts while expanded, so re-renders are cheap.
export const LeadFilterPanel = ({
  controls,
}: {
  controls: LeadListControls;
}) => {
  return (
    <View>
      <LeadSearchBox
        value={controls.searchText}
        onChange={controls.setSearchText}
      />
      <LeadDateRangePicker
        dateFieldLabel={controls.dateFieldLabel}
        onSelectDateField={controls.setDateField}
        presetKey={controls.datePreset}
        onSelectPreset={controls.selectDatePreset}
        rangeStart={controls.rangeStart}
        rangeEnd={controls.rangeEnd}
        customStart={controls.customStart}
        customEnd={controls.customEnd}
        onCustomStart={controls.onCustomStart}
        onCustomEnd={controls.onCustomEnd}
        onClearStart={controls.onClearStart}
        onClearEnd={controls.onClearEnd}
        onClearRange={controls.clearDateRange}
      />
      <OriginIntentionBar
        originKey={controls.originKey}
        onSelectOrigin={controls.setOriginKey}
        intentionKey={controls.intentionKey}
        onSelectIntention={controls.setIntentionKey}
      />
      <SortOwnerBar
        sortKey={controls.sortKey}
        onSelectSort={controls.setSortKey}
        assignee={controls.assignee}
        onSelectAssignee={controls.setAssignee}
      />
    </View>
  );
};
